import React from 'react';

export const getRadioListenerPresenceCount = (presence = {}) => {
  const known = Number(presence?.knownListenerCount || 0);
  const anonymous = Number(presence?.anonymousListenerCount || 0);
  const safeKnown = Number.isFinite(known) && known > 0 ? Math.floor(known) : 0;
  const safeAnonymous =
    Number.isFinite(anonymous) && anonymous > 0 ? Math.floor(anonymous) : 0;
  return safeKnown + safeAnonymous;
};

export default function RadioListenerPresenceRow({
  presence = null,
  label = 'listening now',
  className = 'jg-radio-live-capsule-listeners',
  avatarClassName = 'jg-radio-live-capsule-listener',
  anonymousClassName = '',
  maxVisibleItems = 5,
  showAnonymousBubbles = false,
}) {
  const visibleLimit = Math.max(0, Math.floor(Number(maxVisibleItems) || 0));
  const listenerPreview = Array.isArray(presence?.knownListenersPreview)
    ? presence.knownListenersPreview.slice(0, visibleLimit)
    : [];
  const listenerCount = getRadioListenerPresenceCount(presence);
  const anonymousCount = Math.max(
    0,
    Math.floor(Number(presence?.anonymousListenerCount || 0) || 0),
  );
  const visibleAnonymousCount = showAnonymousBubbles
    ? Math.min(anonymousCount, Math.max(0, visibleLimit - listenerPreview.length))
    : 0;
  const remainingListenerCount = Math.max(
    0,
    listenerCount - listenerPreview.length - visibleAnonymousCount,
  );
  const anonymousClasses = [avatarClassName, anonymousClassName]
    .filter(Boolean)
    .join(' ');

  if (listenerCount <= 0) return null;

  return (
    <span className={className} aria-label={`${listenerCount} ${label}`}>
      {listenerPreview.map((listener) => (
        <span
          className={avatarClassName}
          key={listener.playerId}
          title={`@${listener.displayName || listener.playerId}`}
        >
          {listener.profilePhoto ? (
            <img src={listener.profilePhoto} alt="" width="18" height="18" />
          ) : (
            <span aria-hidden="true">
              {(listener.displayName || listener.playerId || 'J')
                .slice(0, 1)
                .toUpperCase()}
            </span>
          )}
        </span>
      ))}
      {Array.from({ length: visibleAnonymousCount }).map((_, index) => (
        <span
          aria-hidden="true"
          className={anonymousClasses}
          key={`anonymous-${index}`}
          title="Anonymous listener"
        >
          <span aria-hidden="true" />
        </span>
      ))}
      {remainingListenerCount > 0 ? <strong>+{remainingListenerCount}</strong> : null}
      <em>{label}</em>
    </span>
  );
}
